module.exports = __webpack_public_path__ + "img/oh02.63b40837.jpg";